import { useGetMyAccountUsersExcludedDeactivated } from '@/api/queries/me/useGetMyAccountUsersExcludedDeactivated';
import { Select, SelectSizeVariant } from '@payaca/ambrosia';
import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import { FC } from 'react';
import { PermissionGuard } from '../../permissionGuard/PermissionGuard';
import { useListedTimelogsContext } from './listedTimelogsContext';

export const AssigneeFilter: FC = () => {
  const { data: activeUsers } = useGetMyAccountUsersExcludedDeactivated();

  const { input, setFilter } = useListedTimelogsContext();

  const assigneeIds =
    input?.assignees?.filter((a) => a.type === 'USER').map((a) => a.id) || [];

  return (
    <PermissionGuard
      renderIfHasPermissions={[TimelogsPermissions.GET_TIMELOGS]}
    >
      <Select
        sizeVariant={SelectSizeVariant.SM}
        options={
          activeUsers
            ? activeUsers.map((user) => ({
                label: user.fullName,
                value: user.publicId,
              }))
            : []
        }
        placeholder="All users"
        multiple={true}
        value={assigneeIds}
        onChange={(values) => {
          setFilter({
            assignees: values.map((v) => ({
              id: v,
              type: 'USER',
            })),
          });
        }}
        CustomSelected={(selected) => {
          if (selected.selectedOptions.length === 0) {
            return;
          } else if (selected.selectedOptions.length === 1) {
            const user = activeUsers?.find(
              (u) => u.publicId === selected.selectedOptions[0].value
            );
            return user ? user.fullName : '1 user';
          } else {
            return `User - ${selected.selectedOptions.length} selected`;
          }
        }}
        className="w-[16rem]"
      />
    </PermissionGuard>
  );
};
